module.exports = __webpack_public_path__ + "static/media/coi.8972653c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coi.pdf
// module id = 1246
// module chunks = 27